import React from "react";
import MUITable from "Components/UI/Tables/MUITable";
import { useLoaderData } from "react-router-dom";
import { Link } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import LinkIcon from "@mui/icons-material/Link";
import { price2StringPrice } from "utils/priceformatter";

import {
  getParseStatusLabelById,
  getSystemStatusLabelById,
} from "utils/labels";
import {
  getSystemStatusColorByLabel,
  getParseStatusColorByLabel,
} from "utils/colors";
import CommonChip from "Components/UI/Tables/CommonChip";

const createTableRows = (bundles) => {
 
  return bundles?.map((i) => {
    return [
      i.Id,
      price2StringPrice(i.Amount === null ? 0 : i.Amount),
      i.FileId,
      i.InvoiceId,
      i.Title,

      getParseStatusLabelById(i.ParseStatus),
      i.ParseMessage,
      getSystemStatusLabelById(i.SystemStatus),
      i.CreateTime,
    ];
  });
};

export default function ClientInvoiceBundleTable() {
  const { bundles } = useLoaderData();

  const rows = createTableRows(bundles);

  const columns = [
    {
      name: "",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRenderLite: (dataIndex) => {
          return (
            <IconButton
              component={Link}
              to={`${rows[dataIndex][0]}`}
              aria-label="edit"
              size="small"
            >
              <LinkIcon sx={{ p: 0, m: 0 }} />
            </IconButton>
          );
        },
      },
    },
    {
      name: "ID",
      options: {
        filter: false,
      },
    },
    {
      name: "Belopp",
      options: {
        filter: false,
      },
    },
    {
      name: "Fil ID",
      options: {
        // filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/files/${rows[dataIndex][2]}`}>
              {rows[dataIndex][2]}
            </Link>
          );
        },
      },
    },

    {
      name: "Faktura ID",
      options: {
        // filter: false,
        empty: false,
        customBodyRenderLite: (dataIndex) => {
          return (
            <Link to={`/invoices/${rows[dataIndex][3]}`}>
              {rows[dataIndex][3]}
            </Link>
          );
        },
      },
    },
    {
      name: "Klient Title",
      options: {
        filter: false,
      },
    },

    {
      name: "Kontrollstatus",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getParseStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Kontrollmeddelande",
      options: {
        filter: false,
      },
    },
    {
      name: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <CommonChip
              labelName={value}
              color={getSystemStatusColorByLabel(value)}
            />
          );
        },
      },
    },
    {
      name: "Skapad",
      options: {
        filter: false,
      },
    },

    // { name: "Status" },
  ];

  const options = {
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    downloadOptions: {
      separator: ";",
      filename: "all_clients.csv",
    },
    rowsPerPage: 30,
    rowsPerPageOptions: [10, 30, 100],
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
  };

  return (
    <MUITable options={options} title={""} data={rows} columns={columns} />
  );
}
